import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReturnUrlService {
  private readonly storageKey = 'auth_return_url';

  setReturnUrl(url: string | null | undefined) {
    if (!url || !url.startsWith('/')) {
      return;
    }
    sessionStorage.setItem(this.storageKey, url);
  }

  getReturnUrl(): string | null {
    const value = sessionStorage.getItem(this.storageKey);
    if (!value || !value.startsWith('/')) {
      return null;
    }
    return value;
  }

  consumeReturnUrl(): string | null {
    const value = this.getReturnUrl();
    sessionStorage.removeItem(this.storageKey);
    return value;
  }
}
